import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const DashboardPersonalizeElement = ({ slug, availableComponents, position }) => {
  const element = availableComponents.find(c => c.slug === slug);

  if (!element) return null;

  return (
    <div className="dashboard-personalize-element">
      <Button size="sm" color="link" className="drag-handle">
        <i className="fa-solid fa-grip-dots-vertical" />
      </Button>
      <span>
        {element.icon && <i className={element.icon} />}
        {(position.w > 3 || !element.icon) && element.title}
      </span>
    </div>
  );
};

DashboardPersonalizeElement.propTypes = {
  slug: PropTypes.string.isRequired,
  availableComponents: PropTypes.array.isRequired,
  position: PropTypes.object.isRequired,
};

export default DashboardPersonalizeElement;
